export let DirectLineActivityType;
(function (DirectLineActivityType) {
  DirectLineActivityType["Message"] = "message";
  DirectLineActivityType["Typing"] = "typing";
})(DirectLineActivityType || (DirectLineActivityType = {}));